import React from 'react';
import PropTypes from 'prop-types';
import Chip from 'components/interface/Chip/Chip';
import { statusToString } from 'utils/assignment';
import { AssignmentStatus } from 'typings/assignment';

export const STATUS = {
    POSITIVE: 1,
    NEUTRAL: 2,
    NEGATIVE: 3,
    PRIMARY: 4,
    GRAY: 5,
};

export default function StatusChip({ status, ...rest }) {
    const getColor = () => {
        switch (status) {
            case STATUS.POSITIVE:
                return 'green';
            case STATUS.NEUTRAL:
                return 'yellow';
            case STATUS.NEGATIVE:
                return 'pink';
            case STATUS.PRIMARY:
                return 'primary';
            default:
                return 'grey';
        }
    };

    return <Chip color={getColor()} size='small' border {...rest} />;
}

StatusChip.propTypes = {
    status: PropTypes.number.isRequired,
    label: PropTypes.node,
};

export function AssignmentStatusChip({ status, ...rest }) {
    const getColor = () => {
        switch (status) {
            case AssignmentStatus.BOOKED:
                return 'green';
            case AssignmentStatus.TIME_REPORTED:
                return 'yellow';
            case AssignmentStatus.ATTESTED:
                return 'pink';
            default:
                return 'grey';
        }
    };

    return (
        <Chip
            color={getColor()}
            label={statusToString(status)}
            size='small'
            {...rest}
        />
    );
}

AssignmentStatusChip.propTypes = {
    status: PropTypes.string.isRequired,
};
